var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ai-hint-container" }, [
    _c("div", { staticClass: "d-flex gap-10 align-items-center" }, [
      _c(
        "svg",
        {
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "26",
            viewBox: "0 0 24 26",
            fill: "none",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M12 18C12.255 18 12.4689 17.9136 12.6417 17.7408C12.8145 17.568 12.9006 17.3544 12.9 17.1V13.5C12.9 13.245 12.8136 13.0311 12.6408 12.8583C12.468 12.6855 12.2544 12.5994 12 12.6C11.745 12.6 11.5311 12.6864 11.3583 12.8592C11.1855 13.032 11.0994 13.2456 11.1 13.5V17.1C11.1 17.355 11.1864 17.5689 11.3592 17.7417C11.532 17.9145 11.7456 18.0006 12 18ZM12 10.8C12.255 10.8 12.4689 10.7136 12.6417 10.5408C12.8145 10.368 12.9006 10.1544 12.9 9.9C12.9 9.645 12.8136 9.4311 12.6408 9.2583C12.468 9.0855 12.2544 8.9994 12 9C11.745 9 11.5311 9.0864 11.3583 9.2592C11.1855 9.432 11.0994 9.6456 11.1 9.9C11.1 10.155 11.1864 10.3689 11.3592 10.5417C11.532 10.7145 11.7456 10.8006 12 10.8ZM12 22.5C10.755 22.5 9.585 22.2636 8.49 21.7908C7.395 21.318 6.4425 20.6769 5.6325 19.8675C4.8225 19.0575 4.1814 18.105 3.7092 17.01C3.237 15.915 3.0006 14.745 3 13.5C3 12.255 3.2364 11.085 3.7092 9.99C4.182 8.895 4.8231 7.9425 5.6325 7.1325C6.4425 6.3225 7.395 5.6814 8.49 5.2092C9.585 4.737 10.755 4.5006 12 4.5C13.245 4.5 14.415 4.7364 15.51 5.2092C16.605 5.682 17.5575 6.3231 18.3675 7.1325C19.1775 7.9425 19.8189 8.895 20.2917 9.99C20.7645 11.085 21.0006 12.255 21 13.5C21 14.745 20.7636 15.915 20.2908 17.01C19.818 18.105 19.1769 19.0575 18.3675 19.8675C17.5575 20.6775 16.605 21.3189 15.51 21.7917C14.415 22.2645 13.245 22.5006 12 22.5ZM12 20.7C14.01 20.7 15.7125 20.0025 17.1075 18.6075C18.5025 17.2125 19.2 15.51 19.2 13.5C19.2 11.49 18.5025 9.7875 17.1075 8.3925C15.7125 6.9975 14.01 6.3 12 6.3C9.99 6.3 8.2875 6.9975 6.8925 8.3925C5.4975 9.7875 4.8 11.49 4.8 13.5C4.8 15.51 5.4975 17.2125 6.8925 18.6075C8.2875 20.0025 9.99 20.7 12 20.7Z",
              fill: "#2D5089",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c("strong", [_vm._v(_vm._s(_vm.mainText))]),
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        on: {
          click: function ($event) {
            return _vm.openCreatorStudio()
          },
        },
      },
      [
        _c("strong", [_vm._v(_vm._s(_vm._f("trans")("Try Now")))]),
        _vm._v(" "),
        _c("i", { staticClass: "fa fa-arrow-right" }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }